import { Button, IconButton, InputBase, Paper } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../../../assets/images/logo.png';
import Loading from '../../../components/Loading';
import { useLoginPassword } from '../../../context/LoginPassword';
import api from '../../../services/api';
import { isAuthenticated, login as loginAuth } from '../../../services/auth';
import useStyles from './style';
import { encrypt } from '../../../services/crypto';

function Login(props) {
  const classes = useStyles();
  const history = useHistory();
  const { setExpiredLink } = useLoginPassword();

  const [getEmail, setEmail] = useState();
  const [getPassword, setPassword] = useState();
  const [getShowPassword, setShowPassword] = useState(true);
  const [getLoading, setLoading] = useState(false);

  const redirectPage = ({
    configuracoesAmbienteWeb,
    login,
    loginId,
    nome,
    obrigaTrocarSenha,
    paginacao,
    permissions,
    token,
    obrigaRegistrarPonto,
    proximoDiaUtil,
    menuSuperiors,
    menus,
  }) => {
    if (obrigaTrocarSenha) {
      history.push({
        pathname: '/app/troca-senha-obrigatoria',
        state: {
          nome,
          login,
          loginId,
          token,
          permissions,
          paginacao,
          configuracoesAmbienteWeb,
          obrigaRegistrarPonto,
          proximoDiaUtil
        },
      });
    } else {
      sessionStorage.setItem('@Capitalle-Current-Menu', 1)
      if (obrigaRegistrarPonto) {
        loginAuth({
          token,
          nome,
          loginId,
          login,
          permissions,
          paginacao,
          configuracoesAmbienteWeb,
          obrigaRegistrarPonto,
          proximoDiaUtil,
          menuSuperiors,
          menus,
        });
        history.push({
          pathname: '/app/registrar-ponto',
          state: {
            nome,
            login,
            loginId,
            token,
            permissions,
            paginacao,
            configuracoesAmbienteWeb,
            obrigaRegistrarPonto,
            proximoDiaUtil,
          },
        });
      } else {
        loginAuth({
          token,
          nome,
          loginId,
          login,
          permissions,
          paginacao,
          configuracoesAmbienteWeb,
          obrigaRegistrarPonto,
          proximoDiaUtil,
          menuSuperiors,
          menus,
        });

        history.push('/app/home');
      }
    }
  };

  const loginForm = async (event) => {
    event.preventDefault();
    try {
      if (!getEmail || !getPassword) {
        toast.error('Preencha todos os campos para continuar!', {
          position: 'top-right',
          autoClose: 5000,
        });
        return null;
      }
      setLoading(true);

     
      const response = await api.post('Autenticacao/Login', {
        login: getEmail,
        senha: encrypt(getPassword),
      });

      if (response.data.status === 'Inconsistencia') {
        toast.error(response.data.resposta[0].message, {
          position: 'top-right',
          autoClose: 5000,
        });
        setLoading(false);
        return null;
      }

      const {
        token,
        nome,
        loginId,
        modulosPermissoes,
        obrigaTrocarSenha,
        configuracoesAmbienteWeb,
        obrigaRegistrarPonto,
        menusSuperiores,
        menus
      } = response.data.resposta;

      setLoading(false);
      setExpiredLink(false);

      redirectPage({
        configuracoesAmbienteWeb,
        loginId,
        permissions: modulosPermissoes,
        nome,
        obrigaTrocarSenha,
        obrigaRegistrarPonto,
        paginacao: response.data.paginacao,
        login: response.data.resposta.login,
        token,
        proximoDiaUtil: response.data.resposta.proximoDiaUtil,
        menuSuperiors: menusSuperiores,
        menus,
      });
    } catch (err) {
      console.log(err);
      if (err?.response?.data?.status === 'Inconsistencia') {
        toast.error(err.response.data.resposta[0].message, {
          position: 'top-right',
          autoClose: 5000,
        });
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.', {
          position: 'top-right',
          autoClose: 5000,
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isAuthenticated()) {
      history.push('/app/home');
    }
  }, []);

  // if (isLoggedIn) {
  //   return <Redirect to="/app/home" />;
  // }

  return (
    <div className={classes.grid}>
      <img alt="logo" src={Logo} className={classes.logo} />
      <form className={classes.form} onSubmit={(event) => loginForm(event)}>
        <Paper className={classes.root}>
          <PersonOutlineIcon className={classes.icon} />
          <InputBase
            className={classes.inputuserlogin}
            placeholder="USUÁRIO"
            value={getEmail}
            onChange={(e) => setEmail(e.target.value)}
            inputProps={{ 'aria-label': 'user' }}
          />
          <div className={classes.ajustelogin}></div>
        </Paper>
        <Paper className={classes.password}>
          <LockIcon className={classes.icon} />
          <InputBase
            className={classes.input}
            placeholder="SENHA"
            type={getShowPassword ? 'password' : 'text'}
            value={getPassword}
            onChange={(e) => setPassword(e.target.value)}
            inputProps={{ 'aria-label': 'password' }}
          />
          <IconButton
            className={classes.iconButton}
            aria-label="visibility"
            onClick={() => setShowPassword(!getShowPassword)}
          >
            {getShowPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </Paper>
        {getLoading ? (
          <Loading />
        ) : (
          <Button type="submit" variant="contained" className={classes.button}>
            Entrar
          </Button>
        )}
      </form>
    </div>
  );
}

export default Login;
